import {AppPlatformType} from '@toolify/server/src/models/mongoose/SessionModel/enum/AppPlatformType'
import {ThemeType} from '@toolify/server/src/services/UserSettingsService/strategies/ThemeUserSettingStrategy/enum/ThemeType'
import {
  RemovedThemeTypeToThemeTypeMap,
  resolveThemeType,
} from '@toolify/server/src/services/UserSettingsService/strategies/ThemeUserSettingStrategy/functions/resolveThemeType'

function isSupportedTheme(value: unknown): value is string {
  return typeof value === 'string'
    && (Object.values(ThemeType).includes(value as ThemeType) || RemovedThemeTypeToThemeTypeMap.has(value))
}

export function resolveGuestThemeType(input: {
  queryTheme?: unknown
  storedTheme?: unknown
  appPlatformType: AppPlatformType
}): ThemeType {
  if(isSupportedTheme(input.queryTheme)) {
    return resolveThemeType(input.queryTheme)
  }
  if(isSupportedTheme(input.storedTheme)) {
    return resolveThemeType(input.storedTheme)
  }
  if(input.appPlatformType === AppPlatformType.Desktop) {
    return ThemeType.Dark
  }
  return resolveThemeType(undefined)
}
